export default __webpack_public_path__ + "static/media/contact-card-1.901b88ff.svg";